export const INIT = 'app/VolunteerPage/INIT';
export const INIT_SUCCESS = 'app/VolunteerPage/INIT_SUCCESS';
export const INIT_FAILED = 'app/VolunteerPage/INIT_FAILED';

export const SHOW_TAB = 'app/VolunteerPage/SHOW_TAB';

export const FETCH_VOLUNTEER_TIME_OFF_SUMMARY_SUCCESS =
  'app/VolunteerPage/FETCH_VOLUNTEER_TIME_OFF_SUMMARY_SUCCESS';
export const FETCH_VOLUNTEER_TIME_OFF_SUMMARY_FAILED =
  'app/VolunteerPage/FETCH_VOLUNTEER_TIME_OFF_SUMMARY_FAILED';
export const FETCH_VOLUNTEER_TIME_OFFS_SUCCESS =
  'app/VolunteerPage/FETCH_VOLUNTEER_TIME_OFFS_SUCCESS';
export const FETCH_VOLUNTEER_TIME_OFFS_FAILED =
  'app/VolunteerPage/FETCH_VOLUNTEER_TIME_OFFS_FAILED';

export const IMPERSONATE = 'app/VolunteerPage/IMPERSONATE';
export const IMPERSONATE_SUCCESS = 'app/VolunteerPage/IMPERSONATE_SUCCESS';
export const IMPERSONATE_FAILED = 'app/VolunteerPage/IMPERSONATE_FAILED';
